import { Styles } from "../../../../types/common";

const styles: Styles = {
  wrapper: {
    "& .seperator": {
      border: "1px dashed #009D8C",
      marginTop: "60px",
      marginBottom: "40px",
    },
    "& .truncate_overflow": {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      position: "relative",
    },
    "& .popup_data": {
      display: "none",
      background: "black",
      color: "white",
      position: "absolute",
      bottom: "100%",
      fontSize: "12px",
      borderRadius: "8px",
      padding: "5px",
    },
    "& .truncate_overflow:hover + .popup_data": {
      display: "block",
    },
    "& .MuiTextField-root + .popup_data": {
      bottom: "calc(100% - 25px)",
    },
  },
  candidateBox: {
    width: { md: "65%" },
    "& .main_label": {
      fontSize: "20px",
      fontWeight: "700",
      color: "#23085A",
      marginTop: "20px",
    },
  },
  formBox: {
    marginTop: "20px",
    "& .field": {
      "& .select_box_label": {
        marginBottom: "8px",
        fontSize: "14px",
      },
      "& .form_drop__placeholder": {
        color: "#c8c8c8",
        fontSize: "14px",
      },
      "& .form_drop__value-container": {
        padding: "0 15px",
        height: "48px",
      },
      "& .form_drop__input-container": {
        height: "48px",
        padding: "0",
        margin: "0",
      },
      "& .form_drop__control--is-focused": {
        borderColor: "#c8c8c8",
        boxShadow: "none",
      },
      "& .form_drop__control--menu-is-open": {
        borderColor: "#c8c8c8",
        boxShadow: "none",
      },
      "& .form_drop__menu": {
        marginTop: "2px",
      },
    },
  },
  infoBox: {
    "& .para": {
      "& .para_head": {
        margin: "20px 0",
        fontSize: "14px",
        fontWeight: "700",
        color: "#23085A ",
      },
      "& .para_text": {
        fontSize: "16px",
        "& a": {
          color: "#035C67",
          cursor: "pointer",
          textDecoration: "underline",
        },
      },
    },
  },
  modalBody: {
    borderRadius: "8px",
    background: "#F0FCF8",
    padding: "16px",
    marginBottom: "28px",
  },
};

export default styles;
